import { render, staticRenderFns } from "./EmployeeSocialInsuranceRegistrationOverview.vue?vue&type=template&id=913229e2&scoped=true&"
import script from "./EmployeeSocialInsuranceRegistrationOverview.vue?vue&type=script&lang=js&"
export * from "./EmployeeSocialInsuranceRegistrationOverview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSocialInsuranceRegistrationOverview.vue?vue&type=style&index=0&id=913229e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913229e2",
  null
  
)

export default component.exports